import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { StoreBranding, StoreDetailsState } from "@core/models/store.interface";
import { Store } from "@ngrx/store";
import { selectStoreDetails } from "@shared/store/store-details/selectors";
import { take } from "rxjs";
import { environment } from "../../../environments/environment";
import { CarouselComponent } from "./_components/carousel/carousel.component";
import { SlideInterface } from "@core/models/common.interface";

@Component({
  selector: "app-landing-page",
  standalone: true,
  imports: [CarouselComponent],
  templateUrl: "./landing-page.component.html",
  styleUrl: "./landing-page.component.scss",
})
export class LandingPageComponent implements OnInit {
  slides: SlideInterface[] = [];
  protected readonly environment = environment;

  constructor(
    private router: Router,
    private store: Store<{ storeDetails: StoreDetailsState }>,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.getStoreDetails();
  }

  getStoreDetails() {
    this.store
      .select(selectStoreDetails)
      .pipe(take(1))
      .subscribe({
        next: (state) => {
          if (state?.storeName) {
            this.setupSlides(state?.storeBranding);
          }
        },
      });
  }
  setupSlides(storeImages: StoreBranding) {
    this.slides = [
      {
        url: storeImages.landingImage,
        title: "Join +more or log in to your account to access free Wifi ",
        subtitle: "Stay connected to your rewards when you need it most",
      },
      {
        url: "assets/branding/Khanyisile.png",
        title: "Unlock instant savings with +more at 20+ retailers. ",
        subtitle: "Join for free in under 2 minutes",
      },
      {
        url: "assets/branding/register.png",
        title: "Already have a +more digital card?",
        subtitle: "Get started, link your card today and get access to more",
      },
    ];
  }
}
